const rawSkipAuth = `${process.env.REACT_APP_SKIP_AUTH || ""}`.trim().toLowerCase();
const runtimeHost =
    typeof window !== "undefined" ? `${window.location.hostname || ""}`.trim().toLowerCase() : "";
const isLocalHost = ["localhost", "127.0.0.1", "::1"].includes(runtimeHost);

export const SKIP_AUTH = isLocalHost && ["1", "true", "yes", "on"].includes(rawSkipAuth);

export function getDevAuthUser() {
    return {
        user_id: 1,
        email: "local@localhost",
        username: "local-dev",
        role: "user",
        scope_type: "user",
        scope_id: 1,
    };
}
